import sanitizeHtml from 'sanitize-html';

/**
 * Очищает HTML от потенциально опасного содержимого (XSS),
 * оставляя только безопасные теги для отображения markdown-контента
 */
export function sanitize(html: string): string {
    return sanitizeHtml(html, {
        allowedTags: [
            // Заголовки
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            // Текстовое форматирование
            'p',
            'br',
            'strong',
            'b',
            'em',
            'i',
            'u',
            's',
            'del',
            'mark',
            'code',
            'pre',
            'blockquote',
            // Списки
            'ul',
            'ol',
            'li',
            // Ссылки
            'a',
            // Разделители
            'hr',
            // Таблицы
            'table',
            'thead',
            'tbody',
            'tr',
            'th',
            'td',
            // Контейнеры
            'div',
        ],
        allowedAttributes: {
            a: ['href', 'title', 'target', 'rel'],
            code: ['class'],
            pre: ['class'],
            div: ['class'],
        },
        allowedSchemes: ['http', 'https', 'mailto'],
        allowedSchemesByTag: {
            a: ['http', 'https', 'mailto'],
        },
        transformTags: {
            a: (tagName, attribs) => {
                const href = attribs.href || '';

                if (href.startsWith('http://') || href.startsWith('https://')) {
                    return {
                        tagName,
                        attribs: {
                            ...attribs,
                            // Для внешних ссылок: защищаемся от "tabnabbing" и утечки реферер
                            target: '_blank',
                            rel: 'noopener noreferrer',
                        },
                    };
                }

                return {
                    tagName,
                    attribs,
                };
            },
        },
    });
}
